export enum shapeType {
  Rectangle = 'Rectangle',
  Line = 'Line',
  Polygon = 'Polygon',
  LineString = 'LineString',
  Point = 'Point'
  // Circle = 'Circle',
  // CircleMarker = 'CircleMarker'
}
